var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3",staticStyle:{"margin-left":"10px","margin-top":"80px"}},[_c('div',{staticClass:"col-md-12 no-job-dispaly"},[_vm._v("\n        "+_vm._s("You don't have Access to this page")+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }